import { UserAccountType } from "@zeal/common";

export function getUsePrimaryUrlParams(usePrimary: boolean) {
  const params = new URLSearchParams({
    usePrimary,
  } as unknown as Record<string, string>);
  const uri = `?${params.toString()}`;

  return uri;
}

export function getWorkerPathFromUserType(workerType: UserAccountType) {
  switch (workerType) {
    case UserAccountType.CompanyContractor:
      return "contractors";
    case UserAccountType.CompanyWorker:
      return "employees";
    default:
      throw new Error(
        `workerType must be contractor or worker, ${workerType} received.`
      );
  }
}
